Ensure 24/7 coverage with flexible rotations and schedules.

## Rotations

Rotations define the cyclic order of users who share on-call responsibility.

### Configuration

- **Type**:
  - **Daily**: Shifts change every day.
  - **Weekly**: Shifts change every week.
  - **Custom**: Define a shift length in hours/days.
- **Handoff Time**: The specific wall-clock time when the shift transfers from User A to User B.
  - _Tip: Set handoff times during working hours (e.g., 10:00 AM) to ensure smooth transitions._
- **Participants**: The ordered list of users. You can drag-and-drop to reorder.

## Schedules

Schedules are the "Calendar" layer that determines who is actually on-call at any specific second. They can combine multiple rotations and manual assignments.

### Assignments

A schedule is built from one or more **Target** assignments:

1.  **Rotation**: Links to an existing Rotation. The schedule follows the rotation's cycle.
2.  **User**: Permanently assigns a user to the schedule (rarely used alone, usually part of a rule).

### Rules (Time of Day Coverage)

You can restrict _when_ a specific assignment is active.

- **Always (24/7)**: The assignment is always active.
- **Day of Week & Time**: e.g., "Mon-Fri 09:00 - 17:00".
- _Use Case: Create a "Follow the Sun" schedule by assigning a US Rotation during US hours and an EU Rotation during EU hours._

### Overrides

Overrides allow you to manually replace or remove a user for a specific time range.

- **Add**: Assign a simplified replacement for a vacationing user.
- **Remove**: Leave a gap in coverage (not recommended unless intended).
- **Replace**: Select "User A" to be replaced by "User B" for a specific duration.

#### Creating an Override

1.  Go to the Schedule page.
2.  Click/Drag on the Calendar view OR click **Overrides** > **Create Override**.
3.  Select the **start** and **end** time.
4.  Choose the **Add** or **Replace** operation.
